module.exports = __webpack_public_path__ + "static/media/rangi.accde5fb.png";